var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('columns',[_c('column',{staticClass:"is-12"},[_c('payout-destinations-provider',{attrs:{"brand-id":_vm.brandId},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var $affPDData = ref.$affPDData;
return [_c('is-loading',{attrs:{"if":$affPDData.isLoading}},[_c('account-settings-form',{attrs:{"account-id":_vm.accountId}})],1)]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }